import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import toast from 'react-hot-toast';
import { miscRatesSelector, fetchMiscRates, updateMiscRate, addMiscRate } from 'slices/miscRateSlice';
import { CustomSwitch } from 'components/common/Switch';
import { SubmitButton } from 'components/common/buttons/SubmitButton';
import ErrorMessage from 'components/common/ErrorMessage';
import { Modal } from 'reactstrap';

const AddMiscRateForm = ({ item, handleClose, callback, statusPerm }) => {
    const dispatch = useDispatch();
    const [formValues, setFormValues] = useState({
        certification_type: '',
        pay_rate: '',
        status: 1
    });

    const { error, loader } = useSelector(miscRatesSelector);

    // Populate form when editing
    useEffect(() => {
        if (item?.id) {
            setFormValues({
                certification_type: item?.certification_type || "",
                pay_rate: item?.pay_rate || "",
                status: item?.status === "active" || item?.status === 1 ? 1 : 0
            });
        } else {
            setFormValues({
                certification_type: '',
                pay_rate: '',
                status: 1
            });
        }
    }, [item]);

    // Handle input change
    const handleChange = (e) => {
        setFormValues({ ...formValues, [e.target.name]: e.target.value });
    };

    const handleStatusChange = (checked) => {
        setFormValues((prev) => ({ ...prev, status: checked ? 1 : 0 }));
    };

    // Callback after API call
    const submitCallback = (status, message) => {
        if (status) {
            callback();
            toast.success(message, { className: "successToast" });
            dispatch(fetchMiscRates());
            handleClose();
        } else {
            toast.error(message, { className: "errorToast" });
        }
    };

    // Submit form
    const handleSubmit = (event) => {
        event.preventDefault();
        if (item?.id) {
            dispatch(updateMiscRate(formValues, item?.id, submitCallback));
        } else {
            dispatch(addMiscRate(formValues, submitCallback));
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            <div className="row-primary">
                <h2>Certification Type *</h2>
                <input
                    onChange={handleChange}
                    required
                    name="certification_type"
                    className="input-in type_inp"
                    type="text"
                    placeholder="Certification Type"
                    value={formValues.certification_type}
                />
            </div>

            <div className="row-primary">
                <h2>Pay Rate *</h2>
                <input
                    onChange={handleChange}
                    required
                    name="pay_rate"
                    className="input-in type_inp"
                    type="number"
                    placeholder="Pay Rate"
                    value={formValues.pay_rate}
                />
            </div>

            {statusPerm && (
                <div className="row-primary flex-row align-items-center" style={{ alignItems: 'center' }}>
                    <h2 className="mt-0">Status</h2>
                    <CustomSwitch labelText="active" checked={formValues.status === 1} handleChange={handleStatusChange} />
                </div>
            )}

            {error?.errors &&
                Object.keys(error.errors).map((key) =>
                    error.errors[key].map((errMsg, i) => (
                        <div key={i} style={{ marginBottom: 10 }}>
                            <ErrorMessage text={errMsg} />
                        </div>
                    ))
                )}

            <div className="Form-footer">
                <button type="button" className="Cancle_button" onClick={handleClose}>
                    Cancel
                </button>
                <SubmitButton btnText={item?.id ? "Update" : "Create"} loader={loader} />
            </div>
        </form>
    );
};


const AddMiscRate = ({ show, item, onClose, callback, statusPerm }) => {
    return (
        <Modal isOpen={show} toggle={onClose} centered className="modal-medium">
            <div className="modal-content full_modal">
                <div className="modal-header header_modal align-items-center">
                    <h5 className="modal-title_u">{item?.id ? "Update" : "Add"} Miscellaneous Rate</h5>
                    <button type="button" className="btn-close" onClick={onClose}></button>
                </div>
                <div className="modal-body modal_form_body">
                    <AddMiscRateForm item={item} handleClose={onClose} callback={callback} statusPerm={statusPerm} />
                </div>
            </div>
        </Modal>
    );
};

export default AddMiscRate;
